(function() {
  class ReviewsSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.swiper = null;

      this.setupElements();
      this.initSwiper();
    }

    setupElements() {
      this.swiperContainer = this.container.querySelector('.reviews-slider__swiper');
      this.pagination = this.container.querySelector('.reviews-slider__pagination');
      this.prevButton = this.container.querySelector('.reviews-slider__nav-button--prev');
      this.nextButton = this.container.querySelector('.reviews-slider__nav-button--next');
    }

    initSwiper() {
      if (!this.swiperContainer || typeof Swiper === 'undefined') {
        console.warn('ReviewsSlider: Swiper not loaded yet or container missing');
        return;
      }

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: false,
        centeredSlides: false,
        grabCursor: true,
        initialSlide: 1,

        pagination: {
          el: this.pagination,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },

        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },

        breakpoints: {
          990: {
            spaceBetween: 18,
          },
        },
      });
    }
  }

  function initAllSliders() {
    const containers = document.querySelectorAll('[data-section-type="reviews-slider"]');
    containers.forEach((container) => {
      if (!container.dataset.swiperInitialized) {
        new ReviewsSlider(container);
        container.dataset.swiperInitialized = 'true';
      }
    });
  }

  function waitForSwiper(callback, maxAttempts = 50) {
    let attempts = 0;
    const check = () => {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(check, 100);
      } else {
        console.error('ReviewsSlider: Swiper failed to load');
      }
    };
    check();
  }

  // Initialize when DOM is ready and Swiper is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForSwiper(initAllSliders);
    });
  } else {
    waitForSwiper(initAllSliders);
  }

  // Shopify editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('[data-section-type="reviews-slider"]');
      if (container) {
        container.dataset.swiperInitialized = '';
        waitForSwiper(() => new ReviewsSlider(container));
      }
    });
  }
})();
